import Container from 'typedi'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import OrganizationService from '../services/organization.service'

@Module({
  namespaced: true
})
export default class OrganizationsStore extends VuexModule {
    organizations: any[] = []
    organization: any = {}

    @Mutation
    SET_ORGANIZATIONS (payload: any) {
      this.organizations = payload
    }

    @Mutation
    SET_ORGANIZATION (payload: any) {
      this.organization = payload
    }

    @Mutation
    APPEND_ORGANIZATIONS (payload: any[]): void {
      const uuids = this.organizations.map(organization => organization.uuid)
      for (let i = 0; i < payload.length; i++) {
        if (uuids.includes(payload[i].uuid)) continue
        this.organizations.push(payload[i])
      }
    }

    @Action({ rawError: true })
    async getOrganizations (payload: any) {
      const { event_uuid } = payload
      const response = await Container.get(OrganizationService).getOrganizations(event_uuid)
      this.context.commit('SET_ORGANIZATIONS', response.data)
      return response.data
    }

    @Action({ rawError: true })
    async getOrganizationsWithParticipants (payload: any) {
      const { event_uuid, skip, limit, meta } = payload
      return await Container.get(OrganizationService).getOrganizationsWithParticipants(event_uuid, { skip, limit, meta })
    }

    @Action({ rawError: true })
    async getOrganization (payload: any) {
      const { event_uuid, organization_uuid } = payload
      const response = await Container.get(OrganizationService).getOrganization(event_uuid, organization_uuid)
      this.context.commit('SET_ORGANIZATION', response.data)
      return response.data
    }

    @Action({ rawError: true })
    async createOrganization (payload: any) {
      const { data, event_uuid } = payload
      const response = await Container.get(OrganizationService).addOrganization(data, event_uuid)
      this.context.dispatch('getOrganizations', payload)
      return response.data
    }

    @Action({ rawError: true })
    async editOrganization (payload: any) {
      const { data, event_uuid, organization_uuid } = payload
      const response = await Container.get(OrganizationService).updateOrganization(data, event_uuid, organization_uuid)
      this.context.dispatch('getOrganizations', payload)
      return response.data
    }

    @Action({ rawError: true })
    async deleteOrganization (payload: any) {
      const { event_uuid, organization_uuid } = payload
      const response: any = await Container.get(OrganizationService).deleteOrganization(event_uuid, organization_uuid)
      this.context.dispatch('getOrganizations', payload)
      return response
    }
}
